import client from './client';

export const listGroups = () => client.get('/groups').then((r) => r.data);
export const createGroup = (name) => client.post('/groups', { name }).then((r) => r.data);
export const updateGroup = (id, name) => client.put(`/groups/${id}`, { name }).then((r) => r.data);
export const removeGroup = (id) => client.delete(`/groups/${id}`).then((r) => r.data);
export const setGroupHead = (id, userId) =>
  client.post(`/groups/${id}/head`, { userId }).then((r) => r.data);
